import { AbstractBlockFactory } from '../block/AbstractBlockFactory';
import {
    BlockType,
    ChartComponentSettings,
    ComponentSettingsChartMeasureField,
    NewBlockContextType,
} from '@report-content';
import { YNValues } from 'tools/types';

export class BlockFactoryMapChart extends AbstractBlockFactory<ComponentSettingsMapChart> {
    public getNewBlock({
        nextUId,
        nextSortOrder,
        datasetFields,
    }: NewBlockContextType): BlockType<ComponentSettingsMapChart> {
        const uid = 'block_uid_' + nextUId;
        return {
            // TODO:
            component: {
                datasetRendererBlockComponentId: nextUId,
                datasetRendererBlockId: nextUId,
                datasetRendererComponentId: nextUId,
                displayOrder: nextSortOrder,
                internalName: 'map_chart',
                settings: {
                    uid: uid,
                    internal_name: 'map_chart',
                    dataQueries: {
                        table: {
                            resultFieldAggregations: {},
                            resultFields: [],
                            sort: [],
                        },
                    },
                    component_name: 'Map',
                    title: '',
                    height: 600,
                    is_collapsed_ind: 'N',
                    show_in_viewer: 'Y',
                    include_in_email: 'Y',
                    // is_preview_ind: 'Y',
                    groupFilter: { operator: 'AND', rules: [] },
                    include_in_email_attachment: 'Y',
                    //@ts-ignore
                    measureFields: [datasetFields[0]],
                    group_field: datasetFields[0].reference_name,
                    display_label: 'with_data_only',
                    display_full_label: 'Y',
                    color_start: '#EFEFFF',
                    color_end: '#7CB5EC',
                    map: 'custom/world.js',
                    report_no_units_label: 'No exceptions',
                    report_single_unit_label: 'exception',
                    report_multiple_units_label: 'exceptions',
                    isOnCreation: true,
                },
            },
            // datasetRendererBlockId: number;
            displayOrder: nextSortOrder,
            // elementId: number;
            uid: uid,
        };
    }
}

export interface ComponentSettingsMapChart extends ChartComponentSettings {
    uid: string;
    component_name: 'Map';
    internal_name: 'map_chart';
    measureFields: Array<ComponentSettingsChartMeasureField>;
    group_field: string;
    display_label: YNValues | 'with_data_only';
    display_full_label: YNValues;
    color_start: string;
    color_end: string;
    map: string;
    report_no_units_label: 'No exceptions';
    report_single_unit_label: 'exception';
    report_multiple_units_label: 'exceptions';
}
